import React from 'react'
import { StyledButton, TextFields, Wrapper } from '../../components'
import classes from './Login.module.css'
import { Box, CircularProgress, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useDispatch, useSelector } from 'react-redux'
import { setLoader, setisAuthenticated } from '../../redux/globalSlice'
// import { useGlobal } from '../../shared'
import { baseURL, urls } from '../../shared/config'
import axios from 'axios'

const LoginScreen = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loader } = useSelector((state) => state.global)
  // const [needsOTP, setNeedsOTP] = useState(false)
  // const [user, setUser] = useState(null)
  // const [userNumber, setUserName] = useState('')
  const initialValues = {
    // countryCode: '+91',
    // phoneNumber: '',
    email: '',
    password: '',
  }

  const validationSchema = Yup.object({
    // phoneNumber: Yup.string()
    //   .required('Phone number is required')
    //   .matches(/^\+?[0-9]{10,}$/, 'Invalid phone number format.'),
    password: Yup.string().required('Password is required'),
    email: Yup.string()
      .required('Email is required')
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        'Enter a valid email address (e.g., name@example.com)',
      ),
  })
  const formik = useFormik({
    initialValues,
    validationSchema,

    onSubmit: async (values) => {
      const verfyUrl = `${baseURL}${urls.CHECK_USER}`
      const apiUrl = `${baseURL}${urls.LOGIN}`
      // const username = `${values.phoneNumber}`
      // setUserName(username)
      try {
        dispatch(setLoader(true))
        const response = await axios.post(apiUrl, {
          email: values.email,
          password: values.password,
        })

        // const responseData = ()
        if (response?.data?.status === 200) {
          const idtoken = response?.data?.idToken

          const Verifyresponse = await axios.post(verfyUrl, {
            token: idtoken,
          })

          const schoolId = Verifyresponse?.data?.data?.[0]?.school_id
          const school_fee_method = Verifyresponse?.data?.data?.[0]?.school_fee_method
          const userData = Verifyresponse?.data?.data?.[0]

          if (schoolId) {
            localStorage.setItem('userSchoolId', schoolId)
            localStorage.setItem('school_fee_method', school_fee_method)
            if (userData === 'Teacher') {
              toast.error('Teacher Not Authorised!')
              return
            } else {
              localStorage.setItem('userAttributes', JSON.stringify(userData))
              dispatch(setisAuthenticated(true))
              navigate('/dashboard')
            }
          } else {
            return toast.error('Invalid Creds')
          }
          // const signedInUser = await Auth.signIn(username)
          // console.log('----signwdInUser', signedInUser)

          // localStorage.setItem('user', signedInUser)
          // setUser(signedInUser)
          // if (signedInUser.challengeName === 'CUSTOM_CHALLENGE') {
          //   setNeedsOTP(true)
          // } else {
          //   navigate('/dashboard')
          // }
        } else {
          toast.error('Invalid Creds')
        }
      } catch (error) {
        dispatch(setLoader(false))
        console.error('Error signing in:', error)
        if (error.message.includes('Incorrect Email')) {
          toast.error('The email provided is incorrect. Please check and try again.')
        } else {
          toast.error('Something went wrong. Please try again.')
        }
      } finally {
        dispatch(setLoader(false))
      }
    },
  })

  // const handleOTPSubmit = async (otp) => {
  //   try {
  //     dispatch(setLoader(true))
  //     const response = await Auth.sendCustomChallengeAnswer(user, otp)
  //     if (response.challengeName === undefined || response.challengeName === null) {
  //       const currentUser = await Auth.currentAuthenticatedUser()
  //       const currentSession = await Auth.currentSession()
  //       const attributes = currentUser.attributes
  //       localStorage.setItem('userAttributes', JSON.stringify(attributes))
  //       if (currentSession) {
  //         if (attributes?.employee_type == 'Teacher') {
  //           toast.error('Teacher Not Authorised!')
  //           return
  //         } else {
  //           dispatch(setisAuthenticated(true))
  //           navigate('/dashboard')
  //         }
  //       } else {
  //         console.error('Failed to refresh session')
  //       }
  //     } else {
  //       toast.error('Incorrect OTP')
  //     }
  //   } catch (error) {
  //     dispatch(setLoader(false))
  //     console.error('Error verifying OTP:', error)
  //     toast.error('Error verifying OTP')
  //   } finally {
  //     dispatch(setLoader(false))
  //   }
  // }

  return (
    <>
      {loader && (
        <div className="circular-box" style={{ height: '100%' }}>
          <CircularProgress />
        </div>
      )}
      {/* <ToastContainer /> */}
      {
        <Wrapper welcomeText={'Hi, Welcome!'} description={'Please insert your email to continue.'}>
          <Typography mb={1} className={classes['textfield-label']}>
            Email
          </Typography>
          <Box mb={1} className={classes['in-a-row']}>
            {/* <TextFields
              width={'20%'}
              name="countryCode"
              value={formik.values.countryCode}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.phoneNumber}
            /> */}
            {/* <TextFields
              width={'75%'}
              name="phoneNumber"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.phoneNumber}
            /> */}
            <TextFields
              width={'100%'}
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.email}
            />
          </Box>
          {formik.touched.email && formik.errors.email && (
            <div className={classes.LoginError}>{formik.errors.email}</div>
          )}
          <Typography mb={1} className={classes['textfield-label']}>
            Password
          </Typography>
          <Box mb={1} className={classes['in-a-row']}>
            <TextFields
              width={'100%'}
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.password}
            />
          </Box>

          {formik.touched.password && formik.errors.password && (
            <div className={classes.LoginError}>{formik.errors.password}</div>
          )}
          <StyledButton onClick={formik.handleSubmit}>Sign In</StyledButton>
        </Wrapper>
      }{' '}
    </>
  )
}

export default LoginScreen

// const DetermineOTP = ({ onOTPSubmit, username }) => {
//   const initialValues = {
//     otpFields: ['', '', '', ''],
//   }

//   const validationSchema = Yup.object().shape({
//     otpFields: Yup.array()
//       .of(
//         Yup.string()
//           .matches(/^[0-9]$/, 'Must be a digit')
//           .required('Required'),
//       )
//       .min(4, 'Must be exactly 4 digits')
//       .max(4, 'Must be exactly 4 digits'),
//   })
//   const onSubmit = async (values) => {
//     const otpValue = values.otpFields.join('')
//     onOTPSubmit(otpValue)
//   }

//   const formik = useFormik({
//     initialValues,
//     validationSchema,
//     onSubmit,
//   })

//   const handleNumericInput = (e, currentIndex) => {
//     let inputValue = e.target.value
//     const numericValue = inputValue.replace(/[^0-9]/g, '')

//     if (inputValue !== numericValue) {
//       inputValue = ''
//     }
//     formik.setFieldValue(`otpFields.${currentIndex}`, inputValue)

//     if (inputValue.length === 0 && currentIndex > 0) {
//       // Proceed with the logic you want to implement.
//       e.preventDefault() // Prevent the default backspace behavior
//       const prevIndex = currentIndex - 1
//       const prevInput = e.target.parentNode.querySelector(`input:nth-child(${prevIndex + 1})`)
//       if (prevInput) {
//         prevInput.focus()
//       }
//     } else if (currentIndex < formik.values.otpFields.length - 1 && inputValue.length === 1) {
//       const nextIndex = currentIndex + 1
//       const nextInput = e.target.parentNode.querySelector(`input:nth-child(${nextIndex + 1})`)
//       if (nextInput) {
//         nextInput.focus()
//       }
//     }
//   }
//   const handleKeyChange = (e, currentIndex) => {
//     let inputValue = e.target.value
//     const numericValue = inputValue.replace(/[^0-9]/g, '')

//     if (inputValue !== numericValue) {
//       inputValue = ''
//     }
//     formik.setFieldValue(`otpFields.${currentIndex}`, inputValue)

//     if (e.keyCode === 8) {
//       if (inputValue.length === 0 && currentIndex > 0) {
//         e.preventDefault()
//         const prevIndex = currentIndex - 1
//         const prevInput = e.target.parentNode.querySelector(`input:nth-child(${prevIndex + 1})`)
//         if (prevInput) {
//           prevInput.focus()
//         }
//       }
//     }
//   }

//   return (
//     <Wrapper
//       welcomeText={'Verification Code'}
//       description={
//         <>
//           Enter the 4-digit code sent to <span className={classes.bolderText}>{username}</span> by{' '}
//           <span className={classes.bolderText}>Whatsapp.</span> Not my number?{' '}
//           <Link to="/change-number" className={classes.changeLink}>
//             Change here
//           </Link>
//         </>
//       }
//     >
//       <Box mb={1} className={classes['otp-var']}>
//         {formik.values.otpFields.map((value, index) => (
//           <input
//             key={index}
//             className={classes['otp-input']}
//             type="text"
//             maxLength="1"
//             value={value}
//             onChange={(e) => handleNumericInput(e, index)}
//             onKeyDown={(e) => handleKeyChange(e, index)}
//           />
//         ))}
//       </Box>
//       {formik.touched.otpFields && formik.errors.otpFields && (
//         <div className={classes.LoginError}>Verification Code is required</div>
//       )}
//       <StyledButton onClick={formik.handleSubmit}>Sign In</StyledButton>
//     </Wrapper>
//   )
// }
